<template>
    <div>
        <div class="smallContent miscContent">
            Confirm your Email
            <br /><br />

            <form @submit.prevent="confirmEmail">
                <input type="submit" value="Confirm" />
            </form>

            <p v-if="message" id="message">{{ message }}</p>
            <router-link
                v-if="store.authenticated"
                id="support"
                :to="{ name: 'subscribe' }"
                >Support Montez Press Radio</router-link
            >
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import axios from "axios";
import { store } from "../store";
import Footer from "./Footer.vue";

export default {
    name: "ConfirmEmail",
    components: {
        Footer,
    },
    data() {
        return {
            store: store,
            message: "",
        };
    },
    methods: {
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        confirmEmail() {
            let myself = this;
            myself.message = "";
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios
                .post("/api/confirm-email", { email: this.$route.params.email })
                .then((response) => {
                    if (response.data.detail == "Success") {
                        localStorage.setItem("authenticated", "success");
                        myself.store.authenticated = true;
                    }
                    myself.message = response.data.message;
                });
        },
    },
    created() {
        axios.get("/api/login-set-cookie");
    },
    activated() {
        this.message = "";
    },
};
</script>

<style scoped>
.miscContent {
    width: min(550px, 100%);
}
#message {
    color: red;
}
#support {
    margin-top: 1rem;
    width: 100%;
    border: 1px solid black;
    background-color: #f9f57d;
    padding: 0.5rem 0.5rem;
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
}
</style>
